import React, { useEffect, useRef, useState } from 'react';
import { MessageCircleIcon, CalendarIcon, AlertCircleIcon } from 'lucide-react';
import { loadCalendlyScript } from '../utils/calendly';
import { contact } from '../data/contact';
type LoadState = 'loading' | 'ready' | 'error';
export function CTASection() {
  const [state, setState] = useState<LoadState>('loading');
  const sectionRef = useRef<HTMLElement>(null);

  // Load Calendly only when the booking section approaches the viewport (Core Web Vitals)
  useEffect(() => {
    let active = true;
    const node = sectionRef.current;
    if (!node) return;
    const load = () => loadCalendlyScript().then(() => active && setState('ready')).catch(() => active && setState('error'));
    const observer = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) {
        observer.disconnect();
        load();
      }
    }, {
      rootMargin: '600px 0px'
    });
    observer.observe(node);
    return () => {
      active = false;
      observer.disconnect();
    };
  }, []);
  return <section ref={sectionRef} id="termin" aria-labelledby="termin-heading" className="py-16 lg:py-28 bg-[#0a0e1a] scroll-mt-16" data-id="element-71" data-mp="1w7f2soqdk3pg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72" data-mp="1r8c37jt5ypov">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start" data-id="element-73" data-mp="1n7iggtrgjgxk">
          <div className="lg:col-span-5 lg:sticky lg:top-28" data-id="element-74" data-mp="2jx9cixfedc5h">
            <h2 id="termin-heading" className="text-3xl lg:text-5xl font-bold text-white mb-6" data-id="element-75" data-mp="2jyu4cfabugzn">
              Kostenlose Close CRM Beratung buchen
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed mb-8" data-id="element-76" data-mp="2a5lqxd5iupbx">
              Ob Neustart mit Close oder Wechsel von einer anderen Agentur: Im
              kostenlosen Erstgespräch gehen wir die Checkliste gemeinsam für
              deine Situation durch.
            </p>

            <a href={contact.whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 bg-[#111827] hover:bg-[#1a1f36] border border-white/10 rounded-xl p-5 transition-colors" data-id="element-77" data-mp="2xw8ytyffteyh">
              <span className="w-12 h-12 rounded-full bg-green-500/15 flex items-center justify-center flex-shrink-0" data-id="element-78" data-mp="m9f7qeno4zeh">
                <MessageCircleIcon className="w-6 h-6 text-green-400" aria-hidden="true" data-id="element-79" data-mp="r7gqeyh6mwpf" />
              </span>
              <span data-id="element-80" data-mp="d7fp5hx09n9f">
                <span className="block text-white font-semibold" data-id="element-81" data-mp="d75zjvfvhi49">
                  Lieber direkt per WhatsApp schreiben
                </span>
                <span className="block text-gray-400 text-sm" data-id="element-82" data-mp="3ajh1db0r35e">
                  {contact.whatsappDisplay} · Mo–So, 9–21 Uhr
                </span>
              </span>
            </a>
          </div>

          <div className="lg:col-span-7" data-id="element-83" data-mp="1xokepuuu1k3w">
            <div className="relative bg-[#111827] border border-white/10 rounded-2xl overflow-hidden min-h-[700px]" data-id="element-84" data-mp="1xplycnpwzex8">
              {state === 'loading' && <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 text-gray-400" data-id="element-85" data-mp="3n4wqp03k2nu9">
                  <div className="w-8 h-8 border-4 border-[#ff6b35]/20 border-t-[#ff6b35] rounded-full animate-spin" data-id="element-86" data-mp="3i74ond975lcc" />
                  <span className="text-sm" data-id="element-87" data-mp="qn32t7g9juj">Kalender wird geladen …</span>
                </div>}

              {state === 'error' && <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-8 text-center" data-id="element-88" data-mp="9qjl4bzc3kgm">
                  <AlertCircleIcon className="w-8 h-8 text-amber-400" aria-hidden="true" data-id="element-89" data-mp="5phm9w9bxaf6" />
                  <p className="text-gray-300" data-id="element-90" data-mp="joh8kx9ddd86">
                    Der Kalender konnte nicht geladen werden.
                  </p>
                  <a href={contact.calendlyUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#ff6b35] hover:bg-[#ff5722] text-white px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-91" data-mp="eqo20345mh7d">
                    <CalendarIcon className="w-5 h-5" data-id="element-92" data-mp="2i09baanjwfzw" />
                    Termin in neuem Tab buchen
                  </a>
                </div>}

              {state !== 'error' && <div className="calendly-inline-widget w-full" data-url={contact.calendlyUrl} style={{
              minWidth: '320px',
              height: '700px'
            }} data-id="element-93" data-mp="2ru9newh92li4" />}
            </div>
          </div>
        </div>
      </div>
    </section>;
}